/**
 * 6축 팔 그림(`ArmFigure`)의 치수와 순기구학 — 그림과 떨어뜨려 둔 까닭은 그림 파일이 컴포넌트만 내보내야 해서(react-refresh)다.
 * 링크 길이 · 베이스 좌표는 와이어프레임 `armSVGInner()` 1143행 실물 상수 그대로.
 */
export const ARM_L1 = 74
export const ARM_L2 = 64
export const ARM_L3 = 28
export const ARM_BASE_X = 60
export const ARM_BASE_Y = 178
export const ARM_SHOULDER_X = ARM_BASE_X
export const ARM_SHOULDER_Y = ARM_BASE_Y - 44

/** 각(도) → 라디안 */
const rad = (deg: number) => (deg * Math.PI) / 180

/**
 * 그리퍼 끝(손가락 중심)의 그림 좌표 — 마디 회전과 같은 식(어깨 J2 → 팔꿈치 +J3 → 손목 +J4+180°). 수평 트레이를 바깥 좌표에 그릴 때 쓴다
 * (eric 2026-10-08 「트레이는 수평으로 빼고 넣어야 돼」). ⚠ CSS `rotate()` 와 같은 방향(화면 좌표 · 양의 각이 시계 방향)이다
 */
export function gripperTip(joints: readonly number[]): { x: number; y: number; angle: number } {
  const a2 = joints[1] ?? 0
  const a3 = a2 + (joints[2] ?? 0)
  const a4 = a3 + (joints[3] ?? 0) + 180
  const ex = ARM_SHOULDER_X + ARM_L1 * Math.cos(rad(a2))
  const ey = ARM_SHOULDER_Y + ARM_L1 * Math.sin(rad(a2))
  const wx = ex + ARM_L2 * Math.cos(rad(a3))
  const wy = ey + ARM_L2 * Math.sin(rad(a3))
  /* 손가락 중심 = 손목에서 L3 + 손가락 길이의 반(9) */
  return {
    x: wx + (ARM_L3 + 9) * Math.cos(rad(a4)),
    y: wy + (ARM_L3 + 9) * Math.sin(rad(a4)),
    angle: a4,
  }
}
